import { useDispatch, useSelector } from 'react-redux';
import { selectIsDebitor, selectIsFarmleiter } from '../../store/Navigation.store';
import { getKfzKennzeichen, kfzKennzeichenSelectors } from '../../store/KfzKennzeichen.store';
import { useEffect } from 'react';

export const useFetchKfzKennzeichen = (): void => {
    const dispatch = useDispatch();
    const isDebitor = useSelector(selectIsDebitor);
    const isFarmleiter = useSelector(selectIsFarmleiter);
    const loaded = useSelector(kfzKennzeichenSelectors.loaded);

    useEffect(() => {
        if ((isDebitor || isFarmleiter) && !loaded) {
            dispatch(getKfzKennzeichen());
        }
    }, [isDebitor, isFarmleiter, dispatch, loaded]);
};
